



















































































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment';
import { Form, Menu } from 'element-ui';
import {
  mapState,
  mapActions
} from 'vuex';
import {
  formatUrl
} from '../common/util';
import config from '../config/index';
import store from '../store/store';
import introJs from 'intro.js';
import {
  TaskManageData
} from '../types/task';

declare var _hmt: any;

export default Vue.extend({
  name: 'TaskManage',
  data(): TaskManageData {
    return {
      $refs: {
        createTaskForm: Form
      },
      createTaskForm: {
        taskName: ''
      },
      isShowTask: false,
      rules: {
        taskName: [{
          required: true,
          validator: async (rule: any, value: any, callback: any) => {
            if (value === '') {
              callback(new Error('请输入文件夹名称'));
              return false;
            } else if (/^[\s]+$/.test(value)) {
              callback(new Error('文件夹名称不能都为空格'));
              return false;
            } else if (value.length > 50) {
              callback(new Error('文件夹名称不能大于50位'));
              return false;
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }]
      },
      searchData: {
        taskName: '', // 文件夹名/分组名
        beginTime: '', // 开始时间
        endTime: '' // 结束时间
      },
      pickerOption: {
        disabledDate(time: Date) {
          return time.getTime() > Date.now();
        }
      },
      listLoading: false,
      actionName: '',
      // isInit: true,
      taskId: '',
      taskName: '',
      taskList: [],
      copyTaskList: []
    };
  },
  computed: mapState({
    metaTaskList: (state: any) => store.getters.getTaskList,
    userInfo: (state: any) => store.getters.getUserInfo,
    isShowIntro: (state: any) => store.getters.getIntro
  }),
  watch: {
    isShowIntro(newVal) {
      if (newVal && (this.taskList.length === 0)) {
        this.taskList = [{
          createTime: '2019/7/8',
          paperCount: 2,
          taskId: '',
          taskName: '2019年教职工发表'
        }];
      } else {
        this.taskList = this.copyTaskList.concat([]);
      }
    }
  },
  methods: {
    // 创建文件夹/更改名称
    async createTask(formName: string) {
      let checkExist = false;
      try {
        await this.checkTaskName();
      } catch(err) {
        checkExist = true;
      }
      if(checkExist) return false;

      const action = this.actionName === '创建文件夹' ? 'post' : 'patch';
      const url = this.actionName === '创建文件夹' ? 'Create?' : `Update/FolderName/${this.taskId}`;
      // 如果修改名称和之前的名称一样，则不调用接口
      if (this.taskName === this.createTaskForm.taskName && action === 'patch') {
        this.$message({
          message: `${this.actionName}成功`,
          type: 'success'
        });
        this.changeShowDialog(false);
        return false;
      }
      this.$refs[formName].validate((valid: any) => {
        if (valid) {
          // 事件追踪start
          if (action === 'post') {
            _hmt.push(['_trackEvent', '我的检测-文件夹管理', '创建文件夹', '事件价值', 1]);
          }
          // end
          this.$http[action](`/api/Folder/${url}`, {
            folderName: this.createTaskForm.taskName
          }).then((res: any) => {
            this.$message({
              message: `${this.actionName}成功`,
              type: 'success'
            });
            this.changeShowDialog(false);
            // this.$store.dispatch('setTaskList');
            this.getTaskList();
          });
        }
      });
    },
    // 删除文件夹
    delTask(taskId: string) {
      this.$confirm('删除文件夹将会清空该文件夹下所有检测信息的文件夹归属，建议您将文件夹下的检测信息转移至其他文件夹再删除本文件夹，是否确认删除本文件夹？', '提示', { type: 'warning' }).then(() => {
        // 事件追踪start
        _hmt.push(['_trackEvent', '我的检测-文件夹管理', '删除文件夹', '事件价值', 1]);
        // end
        this.$http.delete(`/api/Folder/Delete/${taskId}`).then((res: any) => {
          this.$message({
            message: `删除成功`,
            type: 'success'
          });
          // this.$store.dispatch('setTaskList');
          this.getTaskList();
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 获取文件夹列表
    getTaskList() {
      if (this.searchData.beginTime > this.searchData.endTime) {
        this.$alert(' 开始时间不能大于结束时间！', '提示');
        return false;
      }
      this.listLoading = true;
      this.$http.get('/api/Folder/FolderList', {
        params: this.searchData
      }).then((data: any) => {
        this.listLoading = false;
        this.taskList = data.result;
        this.copyTaskList = this.taskList.concat([]);
      });
    },
    // 清除查询条件
    clear() {
      this.searchData = {
        taskName: '',
        beginTime: '',
        endTime: ''
      };
      this.searchData.endTime = moment().format('YYYY-MM-DD');
      this.searchData.beginTime = moment(this.searchData.endTime).subtract(1, 'year').format('YYYY-MM-DD');
      this.getTaskList();
    },
    // 检测文件夹名称是否存在
    async checkTaskName() {
      return this.$http.put(`/api/Folder/IsExist/${this.createTaskForm.taskName}`).then((data: any) => data.result);
    },
    // 检测时间发生变化时触发
    changeTime() {
      // 日期转成字符串比较
      // this.searchData.beginTime = new Date(this.searchData.beginTime).toJSON();
      // this.searchData.endTime = new Date(this.searchData.endTime).toJSON();
    },
    // 显示创建文件夹弹窗
    changeShowDialog(mark: boolean, taskId?: string, taskName?: string) {
      this.taskName = taskName;
      this.isShowTask = mark;
      this.taskId = taskId;
      this.actionName = taskId ? '更改名称' : '创建文件夹';
      if (taskId) {
        this.createTaskForm.taskName = taskName || '';
      } else {
        this.createTaskForm.taskName = '';
      }
      if (!mark) {
        this.$refs.createTaskForm.resetFields();
      }
    },
    // 跳转页面
    toUrl(taskName: string) {
      let path = '/myCheckInfo';
      this.$router.push({
        path,
        query: {
          taskName: encodeURIComponent(taskName)
        }
      });
    }
  },
  async mounted() {
    this.searchData.endTime = moment().format('YYYY-MM-DD');
    this.searchData.beginTime = moment(this.searchData.endTime).subtract(1, 'year').format('YYYY-MM-DD');
    this.getTaskList();
  }
});
